import api from "./api";

export type ImportKind = "fee-billings" | "outbound-invoices";

export interface ImportRowMessage {
  row: number;
  message: string;
}

export interface ImportResult {
  success: boolean;
  batchId?: string | null;
  total: number;
  inserted: number;
  updated: number;
  errors: ImportRowMessage[];
  warnings: ImportRowMessage[];
}

export interface ImportBatch {
  batchId: string;
  rows: number;
  importedAt: string;
  periodFrom: string;
  periodTo: string;
  total: number;
}

// Erros de rede/HTTP propagam para quem chama.
export const downloadImportTemplate = async (kind: ImportKind, fileName: string) => {
  const response = await api.get(`/api/dataimport/${kind}/template`, { responseType: "blob" });
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const uploadImport = async (kind: ImportKind, file: File): Promise<ImportResult> => {
  const formData = new FormData();
  formData.append("file", file);
  return (await api.post(`/api/dataimport/${kind}`, formData)).data;
};

export const getImportBatches = async (kind: ImportKind): Promise<ImportBatch[]> =>
  (await api.get(`/api/dataimport/${kind}/batches`)).data;

export const deleteImportBatch = async (kind: ImportKind, batchId: string): Promise<{ success: boolean; notifications: string[] }> =>
  (await api.delete(`/api/dataimport/${kind}/batches/${batchId}`)).data;
